import React, { FC, ReactNode } from 'react';

import { ThemeProvider } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { AccountDialProvider } from 'src/v2/components/ui/accountDial/provider';
import { WagmiConfig } from 'wagmi';

import { AmplitudeProvider } from '~components/providers/AmplitudeProvider';
import { AppStateProvider } from '~components/providers/AppStateProvider';
import { ContractsProvider } from '~components/providers/ContractsProvider';
import { SessionProvider } from '~components/providers/SessionProvider';
import { SettingsProvider } from '~components/providers/SettingsProvider';
import { TransactionProvider } from '~components/providers/TransactionProvider';
import vaultTheme from '~components/theme';
import { wagmiClient } from '~config/wagmiConfig';
import { queryClient } from '~pages/_app';

export const VestaProviders: React.FC<{ children: ReactNode; mock?: boolean }> = ({ children, mock }) => {
  if (mock) {
    return (
      <AppStateProvider>
        <AmplitudeProvider>
          <WagmiConfig config={wagmiClient}>
            <SettingsProvider>
              <SessionProvider>
                <QueryClientProvider client={queryClient}>
                  <TransactionProvider>
                    <AccountDialProvider>
                      <ThemeProvider theme={vaultTheme}>{children}</ThemeProvider>
                    </AccountDialProvider>
                  </TransactionProvider>
                </QueryClientProvider>
              </SessionProvider>
            </SettingsProvider>
          </WagmiConfig>
        </AmplitudeProvider>
      </AppStateProvider>
    );
  }

  return (
    <AppStateProvider>
      <AmplitudeProvider>
        <WagmiConfig config={wagmiClient}>
          <SettingsProvider>
            <SessionProvider>
              <ContractsProvider>
                <QueryClientProvider client={queryClient}>
                  <TransactionProvider>
                    <AccountDialProvider>
                      <ThemeProvider theme={vaultTheme}>{children}</ThemeProvider>
                    </AccountDialProvider>
                  </TransactionProvider>
                </QueryClientProvider>
              </ContractsProvider>
            </SessionProvider>
          </SettingsProvider>
        </WagmiConfig>
      </AmplitudeProvider>
    </AppStateProvider>
  );
};
